import React, { useEffect, useState } from "react";
import axios from "axios";
import { Grid, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Widget from "../../../components/Widget";
import dayjs from "dayjs";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { memberTableState, projectTableState, noticeTableState } from "../../../recoil/tableSetting";

function toCount(value) {
  return Number(value) || 0;
}

function mergeData(arr) {
  const result = [];
  arr.forEach((item) => {
    const dates = item[0];
    const totals = item[1];
    const plans = item[2];
    for (let i = 0; i < 7; i++) {
      result.push({
        date: dates[i],
        totalMember: totals[i],
        subscribeMember: plans[i],
      });
    }
  });
  return result;
}

function changeData(arr, index1) {
  arr.forEach((item) => {
    const value1 = item[index1];
    item[index1] = value1.split("T")[0];
  });
  return arr;
}

function ServiceStatusTable() {
  const today = new Date();
  const todayFormat = dayjs(today).endOf("day");

  const [memberList, setMemberList] = useState(0);
  const [filteredMember, setFilteredMember] = useState(0);
  const [topPlanMemCnt, setTopPlanMemCnt] = useState(null);

  const [totalProject, setTotalProject] = useState([]);
  const [lastWeekTotalProject, setLastWeekTotalProject] = useState([]);

  const [lastWeekAppliProject, setLastWeekAppliProject] = useState([]);
  const [appliProject, setAppliProject] = useState([]);

  const [directList, setDirectList] = useState([]);
  const [waitAppliData, setWaitAppliData] = useState([]);

  const history = useHistory();
  const [, setMemberTable] = useRecoilState(memberTableState);
  const [, setProjectTable] = useRecoilState(projectTableState);
  const [, setNoticeTable] = useRecoilState(noticeTableState);

  const navigateToPage = (num) => {
    let linkTo;

    switch (num) {
      case 1:
        setMemberTable("total");
        linkTo = "/app/researchAll/member";
        break;
      case 2:
        setMemberTable("plan");
        linkTo = "/app/researchAll/member";
        break;
      case 3:
        setProjectTable("total");
        linkTo = "/app/researchAll/project";
        break;
      case 4:
        setProjectTable("patent");
        linkTo = "/app/researchAll/project";
        break;
      case 5:
        setNoticeTable("question");
        linkTo = "/app/researchAll/memberCenter";
        break;
      case 6:
        linkTo = "/app/researchAll/applicant";
        break;
      default:
        break;
    }

    history.push(linkTo);
  };

  useEffect(() => {
    axios
      .get("/api/member/memberGraph?term=" + 2 + "&startDate=" + todayFormat)
      .then((response) => {
        const memberData = mergeData([response.data.data]);
        const yesterdayPlan = toCount(memberData[5]?.subscribeMember.전체합);
        const todayPlan = toCount(memberData[6]?.subscribeMember.전체합);

        setTopPlanMemCnt([yesterdayPlan, todayPlan, todayPlan - yesterdayPlan]);
        setMemberList(toCount(memberData[6]?.totalMember.전체합));
        setFilteredMember(
          toCount(memberData[6]?.totalMember.전체합) - toCount(memberData[5]?.totalMember.전체합)
        );
      });
  }, []);

  useEffect(() => {
    axios
      .get("/api/projects/totalList")
      .then((response) => {
        const projectAPI = response.data.data;
        const sevenDaysAgo = dayjs(today).subtract(7, "day").endOf("day");
        const filteredData = projectAPI.filter((item) =>
          dayjs(item.created_time).isBefore(sevenDaysAgo)
        );
        setLastWeekTotalProject(filteredData);
        setTotalProject(projectAPI);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios
      .get("/api/projects/list")
      .then((response) => {
        const projectAPI = response.data.data;
        const sevenDaysAgo = dayjs(today).subtract(7, "day").endOf("day");
        const filteredData = projectAPI.filter((item) =>
          dayjs(item.created_at).isBefore(sevenDaysAgo)
        );
        setLastWeekAppliProject(filteredData);
        setAppliProject(projectAPI);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios
      .get("/api/memberCenter/weekDirectList")
      .then((response) => {
        const directAPIData = changeData([...response.data.data], "request_date");
        setDirectList(directAPIData);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios
      .get("/api/applicant/assigneeHistory?search_type=TOTAL")
      .then((response) => {
        const applicantAPIData = response.data.data;
        const waitApplicantData = applicantAPIData.filter((item) => item.change_flag == 0);
        setWaitAppliData(waitApplicantData);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const planCount = topPlanMemCnt?.[1] ?? 0;
  const planChange = topPlanMemCnt?.[2] ?? 0;
  const totalProjectChange = totalProject.length - lastWeekTotalProject.length;
  const patentProjectChange = appliProject.length - lastWeekAppliProject.length;

  const cards = [
    {
      id: 1,
      label: "전체 회원",
      value: memberList,
      accent: "#536DFE",
      change: filteredMember,
      sub: "지난주 대비",
    },
    {
      id: 2,
      label: "플랜 회원",
      value: planCount,
      accent: "#2f9e6a",
      change: planChange,
      sub: "지난주 대비",
    },
    {
      id: 3,
      label: "통합 프로젝트",
      value: totalProject.length,
      accent: "#6366f1",
      change: totalProjectChange,
      sub: "지난주 대비",
    },
    {
      id: 4,
      label: "특허 프로젝트",
      value: appliProject.length,
      accent: "#f59e0b",
      change: patentProjectChange,
      sub: "지난주 대비",
    },
    {
      id: 5,
      label: "1:1 문의",
      value: directList.length,
      accent: "#ec4899",
      sub: "이번 주 접수",
    },
    {
      id: 6,
      label: "승인 대기 정비",
      value: waitAppliData.length,
      accent: "#ef4444",
      sub: "처리 대기 중",
      alert: waitAppliData.length > 0,
    },
  ];

  return (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Widget
        noHeaderPadding
        header={
          <Header>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              서비스 운영 현황
            </Typography>
            <DateHint>{dayjs().format("YYYY. MM. DD")} 기준</DateHint>
          </Header>
        }
      >
        <CardRow>
          {cards.map((card) => (
            <StatCard
              key={card.id}
              $accent={card.accent}
              $alert={card.alert}
              onClick={() => navigateToPage(card.id)}
            >
              <StatTop>
                <StatLabel>{card.label}</StatLabel>
                {card.change !== undefined && <ChangeBadge $value={card.change} />}
              </StatTop>
              <StatValue>{toCount(card.value).toLocaleString()}</StatValue>
              <StatBottom>
                <StatSub>{card.sub}</StatSub>
                <GoHint>자세히 보기 →</GoHint>
              </StatBottom>
            </StatCard>
          ))}
        </CardRow>
      </Widget>
    </Grid>
  );
}

function ChangeBadge({ $value }) {
  const value = toCount($value);
  const label = value > 0 ? `+${value}` : `${value}`;

  return <Badge $value={value}>{label}</Badge>;
}

export default ServiceStatusTable;

const Header = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
    padding: 20px 24px 4px;
`;

const DateHint = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
`;

const CardRow = styled.div`
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 12px;

    @media (max-width: 1400px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (max-width: 800px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

const StatCard = styled.button`
    appearance: none;
    font: inherit;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    padding: 18px 18px 16px;
    border-radius: 14px;
    background: ${({ $alert }) => ($alert ? "#fff7f7" : "#f8fafc")};
    border: 1px solid ${({ $alert }) => ($alert ? "#fecaca" : "#eceff3")};
    border-top: 3px solid ${({ $accent }) => $accent};
    text-align: left;
    cursor: pointer;
    transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
        border-color: ${({ $accent }) => $accent}33;
    }
`;

const StatTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 10px;
`;

const StatLabel = styled.div`
    font-size: 13px;
    font-weight: 700;
    color: #64748b;
`;

const StatValue = styled.div`
    font-size: 30px;
    font-weight: 800;
    letter-spacing: -1px;
    color: #0f172a;
    font-variant-numeric: tabular-nums;
    line-height: 1.1;
`;

const StatBottom = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 10px;
`;

const StatSub = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: #94a3b8;
`;

const GoHint = styled.span`
    font-size: 12px;
    font-weight: 700;
    color: #94a3b8;
    opacity: 0;
    transform: translateX(-4px);
    transition: opacity 0.16s ease, transform 0.16s ease, color 0.16s ease;

    ${StatCard}:hover & {
        opacity: 1;
        transform: translateX(0);
        color: #536DFE;
    }
`;

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 42px;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: -0.2px;
    font-variant-numeric: tabular-nums;
    color: ${({ $value }) => ($value > 0 ? "#2563eb" : $value < 0 ? "#e11d48" : "#94a3b8")};
    background: ${({ $value }) => ($value > 0 ? "#eff6ff" : $value < 0 ? "#fff1f2" : "#f1f5f9")};
`;
